import { BaseService, NOME_TOKEN_ACESSO_DIRETO } from '@thema/base-servicos'

const urlDespesasMensais = '/service/contabilidade/loteServico/'

class DespesasMensaisService extends BaseService {
    constructor() {
        const config = JSON.parse(sessionStorage.getItem('config'))
        super(NOME_TOKEN_ACESSO_DIRETO, config)
        const adms = config.adms && config.adms.length > 0 ? config.adms.join() : null
        this.state = {
            adms: adms,
        }
    }

    consultar(filtro) {
        let data = {
            exercicio: filtro.exercicio ? filtro.exercicio.value : '',
            competencia: filtro.competencia && filtro.competencia.value !== null ? filtro.exercicio.value + filtro.competencia.value : null,
            administracao: filtro.administracao && filtro.administracao.length > 0 ? filtro.administracao.map(e => e.value).join(',') : this.state.adms,
            comarca: filtro.predio && filtro.predio.length > 0 ? filtro.predio.map(e => e.value).join(',') : null,
            unidade: filtro.unidade && filtro.unidade.length > 0 ? filtro.unidade.map(e => e.value).join(',') : null,
            chaveUnidade: filtro.unidade && filtro.unidade.length > 0 ? filtro.unidade.map(e => e.chaveUnidade).join(',') : null,
            numeroProduto: filtro.tipoServico && filtro.tipoServico.length > 0 ? filtro.tipoServico.map(e => e.value).join(',') : null,
            cnpj: filtro.cnpj ? filtro.cnpj.replace(/^(\d{2}).(\d{3}).(\d{3})\/(\d{4})-(\d{2})/, '$1$2$3$4$5') : null,
            identificador: filtro.identificador ? filtro.identificador : null,
            nomeFornecedor: filtro.nomeFornecedor ? filtro.nomeFornecedor : null,
        }
        return this.conex.post(urlDespesasMensais + 'despesasMensais/', JSON.stringify(data))
    }
}

export default DespesasMensaisService
